<template>
  <topbar
    position="fixed"
    type="primary"
    :transparent="transparent"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
  >
    <!--class="mobile-bg-primary"-->
    <template slot="navbar-menu">
      <!-- to show only in Mobile devices : helpers.IsWebView() && --->
      <div class="flex nav-left">
        <div class="pull-left">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item mobile icon ml-2 mr-2" v-if="helpers.IsWebView() && !isHome"> 
              <a class="nav-link" @click="goBack()" :disabled="isHome">
                <i class="new-ui-icons k-icon-left-open only-icon"></i>
              </a>
            </li>
            <li class="nav-item icon mobile" v-if="!isHome" :class="{'ml-2' : !helpers.IsWebView() }" >
              <router-link to="/" class="nav-link">
                <i class="new-ui-icons k-icon-home-outline only-icon"></i>
              </router-link>
            </li>
            <li v-if="isAuthenticated" class="nav-item icon mobile ml-2">
              <router-link to="/re-order" class="nav-link">
                <i class="now-ui-icons k-icon-re-order only-icon"></i>
              </router-link>
            </li>
          </ul>  
        </div>
      </div>
      <!-- to show only in desktop devices--->
      <div class="flex nav-right">
        <div class="pull-right">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item icon desktop" :style="[active == 'home' ? myTheme.topMenu.active : '']">
              <router-link to="/" class="nav-link">
                <i class="new-ui-icons k-icon-home-outline only-icon"></i>
                <p class="desktop">{{ $t("button.home") }}</p>
              </router-link>
            </li>
            <li
              v-if="isAuthenticated"
              class="nav-item icon desktop"
              :style="[active == 're-order' ? myTheme.topMenu.active : '']"
            >
              <router-link to="/re-order" class="nav-link">
                <i class="now-ui-icons k-icon-re-order only-icon"></i>
                <p class="desktop">{{ $t("button.re_order") }}</p>
              </router-link>
            </li>
            <li
              class="nav-item desktop"
              v-if="!isLocationEmpty(selectedLocation)"
              :style="[active == 'contactus' ? myTheme.topMenu.active : '']"
            >
              <router-link to="/contactus" class="nav-link">
                <i class="now-ui-icons k-icon-contactus only-icon"></i>
                <p>{{ $t("button.contact") }}</p>
              </router-link>
            </li>
            <li class="nav-item" v-if="!isAuthenticated">
              <div class="pull-right">
                <button
                  v-if="getIsUKApp"
                  class="nav-link btn btn-neutral login-min-width"
                  :style="myTheme.registrationButtons"
                  @click="goToLogin()"
                >
                  <i class="now-ui-icons k-icon-login"></i>
                  <p>{{ $t("button.login") }}</p>
                </button>
                <drop-down v-else title="Account">
                  <button
                    slot="title"
                    class="nav-link btn btn-neutral login-min-width"
                    data-toggle="dropdown"
                    :style="myTheme.registrationButtons"
                  >
                    <p>
                      <img
                        class="language-flag"
                        :src="`/img/${$i18n.locale}.png`"
                      />
                      {{ $t("button.account") }}
                    </p>
                  </button>
                  <a class="dropdown-item" @click.prevent="goToLogin()"
                    ><i class="now-ui-icons k-icon-login"></i>
                    {{ $t("button.login") }}</a
                  >
                  <h6 class="dropdown-header">
                    {{ $t("text.select_language") }}
                  </h6>
                  <div v-for="(lang, index) in enumHelper.locales" :key="index">
                    <a
                      v-if="lang.code != $i18n.locale"
                      @click.prevent="changeLanguage(lang.code)"
                      class="dropdown-item"
                    >
                      <img class="language-flag" :src="lang.flag" />{{
                        $t(lang.name)
                      }}</a
                    >
                  </div>
                </drop-down>
              </div>
            </li>
            <li class="nav-item" v-else>
              <div class="pull-right">
                <button
                  v-if="getIsUKApp"
                  :style="myTheme.registrationButtons"
                  class="nav-link btn btn-neutral btn-account"
                  @click="goToAccount()"
                >
                  <i class="now-ui-icons users_circle-08 mr-1"></i>
                  <p>{{ $t("button.account") }}</p>
                </button>
                <drop-down v-else title="Account">
                  <button
                    slot="title"
                    class="nav-link btn btn-neutral btn-account"
                    data-toggle="dropdown"
                    :style="myTheme.registrationButtons"
                  >
                    <p>
                      <img
                        class="language-flag"
                        :src="`/img/${$i18n.locale}.png`"
                      />{{ $t("button.account") }}
                    </p>
                  </button>
                  <a class="dropdown-item" @click.prevent="goToAccount()"
                    ><i class="now-ui-icons k-icon-login"></i>
                    {{ $t("button.account") }}</a
                  >
                  <h6 class="dropdown-header">
                    {{ $t("text.select_language") }}
                  </h6>
                  <div v-for="(lang, index) in enumHelper.locales" :key="index">
                    <a
                      v-if="lang.code != $i18n.locale"
                      @click.prevent="changeLanguage(lang.code)"
                      class="dropdown-item"
                    >
                      <img class="language-flag" :src="lang.flag" />{{
                        $t(lang.name)
                      }}</a
                    >
                  </div>
                </drop-down>
              </div>
            </li>
            <li class="nav-item" style="width: 100px">
              <button
                @click="onClick"
                class="nav-link btn btn-neutral"
                style="width: 100%"
                :disabled="selectedLocation && !locationStatus.can_make_order"
                :style="{ color: myTheme.primaryTextColor }"
              >
                <i class="new-ui-icons k-icon-basket-2 mr-1"></i>
                <p>{{ orderTotal | currency(currentCurrency) }}</p>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </template>
  </topbar>
</template>

<script>
import { Topbar, DropDown, Button } from "@/components";
import router from "../router";
import { mapState, mapGetters, mapActions } from "vuex";
import { helpers, cartManager, enumHelper } from "@/utilities";
import couponMixin from "../mixins/couponMixin";
export default {
  name: "main-navbar",
  mixins: [couponMixin],
  props: {
    transparent: Boolean,
    colorOnScroll: Number,
  },
  components: {
    Topbar,
    DropDown,
    [Button.name]: Button,
  },
  data() {
    return {
      cart: cartManager.InitCart(),
      enumHelper,
      helpers,
    };
  },
  computed: {
    ...mapGetters(["isAuthenticated", "getIsUKApp"]),
    ...mapState({
      user: (state) => state.auth.user,
      orderTotal: (state) => state.orderTotal,
    }),
    active() {
      return this.$route.name;
    },
    locationStatus: function () {
      return helpers.canMakeOrder(this.selectedLocation, this.isMounted);
    },
    isHome() {
      return this.$route.name === "home";
    },
  },
  methods: {
    ...mapActions(["swicthLanguage"]),
    goToLogin() {
      router.push("/login");
    },
    goToAccount() {
      if (this.isAuthenticated) {
        router.push("/account").catch();
      } else {
        router.push("/login");
      }
    },
    goBack() {
      this.$router.go(-1);
    },

    onClick() {
      this.cart = cartManager.InitCart();
      this.refreshLocationData()
        .then(() => {
          if (
            helpers.controlAvailibilityBeforeCheckout(
              this.locationStatus,
              this.cart
            )
          ) {
            let message = this.$t("message.location_temporary_closed");
            if (this.selectedLocation.openingHours.suspended) {
              message = this.$t("message.location_temporary_paused_to", {
                paused_to: this.selectedLocation.paused_to,
              });
            }

            helpers
              .showErrorMessageAlert(message, null, "red", "OK")
              .then(() => {
                this.goToHome();
              });
          } else {
            helpers
              .checkOrderItemsAvailibility(
                this.cart.order,
                this.$moment(),
                this.locationMenuItems
              )
              .then((itemsNotAvailableFor) => {
                if (
                  itemsNotAvailableFor.today.length ||
                  itemsNotAvailableFor.now.length
                ) {
                  let message = "";
                  if (itemsNotAvailableFor.today.length) {
                    message = `${this.$t(
                      "message.items_not_available_for_today"
                    )} : <br> <ul class='order-items'>`;
                    itemsNotAvailableFor.today.forEach((item) => {
                      message += `<li>${item.name}</li>`;
                    });
                    message += "</ul>";
                  }
                  if (itemsNotAvailableFor.now.length) {
                    message += `${this.$t(
                      "message.items_not_available_for_now"
                    )} : <br> <ul class='order-items'>`;
                    itemsNotAvailableFor.now.forEach((item) => {
                      message += `<li>${item.name}</li>`;
                    });
                    message += "</ul>";
                  }

                  message += `<p class='message'>${this.$t(
                    "message.items_automaticaly_removed"
                  )}</p>`;

                  //--- remove the outdated items
                  let itemsId = itemsNotAvailableFor.today
                    .concat(itemsNotAvailableFor.now)
                    .map((x) => x.id);
                  this.removeItems(itemsId);
                  this.$root.$emit("REFRESH_CART_DATA");
                  this.$root.$emit("REMOVE_ITEMS", itemsId); // to be used from the LocationMenuItem to update the list

                  helpers
                    .showErrorMessageAlert(
                      message,
                      "k-icon-preptime",
                      this.staticColor.orange
                    )
                    .then(() => {
                      this.$nextTick(() => {
                        this.continueWithRedirection();
                      });
                    });
                } else {
                  helpers
                    .checkRequiredMenuItemOptions(this.cart)
                    .then(() => {
                      //--- verify the coupon if any is provided | coupon is only availabled for logged users
                      if (this.user && this.cart.coupon) {
                        this.onSubmitCoupon(false).then(() => {
                          //if (result) {
                          this.continueWithRedirection();
                          //}
                        });
                      } else {
                        this.continueWithRedirection();
                      }
                    })
                    .catch((response) => {
                      helpers.showErrorMessageAlert(
                        response.map((m) => m + "</br>").join(),
                        null,
                        "red",
                        "OK"
                      );
                    });
                }
              })
              .catch((e) => {
                this.captureException(e);
              });
          }
        })
        .catch((e) => {
          this.captureException(e);
          helpers.showErrorMessageAlert(
            this.$t("generic_error.refresh_location_data"),
            null,
            "red",
            this.$t("button.ok")
          );
        });
    },
    continueWithRedirection() {
      router.push({ name: "cart" });
    },
    removeItems(arrItems) {
      //---- get the card
      this.cart.order = this.cart.order.filter((x) => !arrItems.includes(x.id));
      cartManager.setCart(this.cart);
      this.$nextTick(() => {
        this.setCartDeliveryFee();
      });
    },
    setCartDeliveryFee() {
      return new Promise((resolve) => {
        if (
          this.cart.orderType == enumHelper.orderType.Delivery &&
          this.selectedLocation.delivery_condition &&
          this.selectedLocation.availabe_delivery_postcode
        ) {
          if (this.cart.order.length)
            // call this method if the cart total is > to 0
            this.cart.delivery_fee = helpers.getDeliveryFee(
              this.selectedLocation.delivery_condition,
              this.cart.total
            );
          else {
            this.cart.delivery_fee = helpers.getDefaultDeliveryFee(
              this.selectedLocation.delivery_condition
            );
          }
          cartManager.setCart(this.cart, true, false);
          resolve(true);
        }
        resolve(false);
      });
    },
    changeLanguage(code) {
      this.$i18n.locale = code;
      this.swicthLanguage(code);
    },
    goToHome() {
      if(this.$route.name != "home"){
        router.push("/");
      }
    },
  },
};
</script>
<style>
.language-flag {
  max-width: 20px;
  padding-right: 5px;
}
.navbar-nav {
  width: 100%;
}
.nav-left {
  width: 39%;
}
.nav-right {
  width: 59%;
}
.btn-account {
  min-width: 95px;
}
.login-min-width{
  min-width: 116px;
}
</style>
